import React from 'react';

const CustomerInternetSpeed = (props) => {
    return (
        <div className={`customer-internet-speed ${props.cssClass}`}>
            <div className='customer-speed-title'> מהירות הגלישה שלך היא </div>
            <div className='customer-speed-data'>
                <div className='download-speed'> הורדה עד {props.downloadSpeed}MB </div>
                <div className='speed-sep'></div>
                <div className='upload-speed'> העלאה עד {props.uploadSpeed}MB </div>
            </div>
        </div>
    );
};

export default CustomerInternetSpeed;